import { render } from "./WhitelistEditor.vue?vue&type=template&id=2124de93"
import script from "./WhitelistEditor.vue?vue&type=script&lang=js"
export * from "./WhitelistEditor.vue?vue&type=script&lang=js"

import "./WhitelistEditor.vue?vue&type=style&index=0&id=2124de93&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__